import { MAX_PHOTOS_PER_DELETE } from "@rebuild/shared";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeletePhotosDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  photoCount: number;
  /** Selected photos held back because a single request is capped. */
  overflowCount: number;
}

export function DeletePhotosDialog({ open, onOpenChange, onConfirm, photoCount, overflowCount }: DeletePhotosDialogProps) {
  const photoLabel = `${photoCount} photo${photoCount === 1 ? "" : "s"}`;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="!bg-white text-black">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-lg font-medium text-gray-800">Delete {photoLabel}?</AlertDialogTitle>
          <AlertDialogDescription className="mt-2 text-sm text-gray-600">
            {photoLabel} will be removed from this project.
            {overflowCount > 0 &&
              ` Up to ${MAX_PHOTOS_PER_DELETE} photos can be deleted at a time, so the remaining ${overflowCount} will stay selected.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-6 flex gap-2">
          <AlertDialogAction variant="destructive" onClick={onConfirm}>
            Delete {photoLabel}
          </AlertDialogAction>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
